module.exports = __webpack_public_path__ + "static/media/chat icon.6183f26a.svg";